export default {
      id: "map_google_icon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#map_google_icon",
      toString: function () {
        return this.url;
      }
    }